module.exports = __webpack_public_path__ + "img/12217_11.df791b76.png";